import { Injectable } from '@angular/core';
import { GetStockByTargetAndBarcodeCacheGQL, StockType } from '@sifca-monorepo/ecommerce-generator';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StockService {
  // Private
  private stock: BehaviorSubject<StockType[] | null> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(private getStockByTargetAndBarcodeGQL: GetStockByTargetAndBarcodeCacheGQL) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for slides
   */
  get stock$(): Observable<StockType[]> {
    return this.stock.asObservable();
  }

  getStockByTargetAndBarcode(pos: string, barcode: string): Observable<StockType[]> {
    return this.getStockByTargetAndBarcodeGQL
      .fetch({
        barcode,
        target: { pos },
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.getStockByTargetAndBarcodeCache;
          }
        }),
      );
  }
}
